import { POST_PREPARE, POST_PREPARE_SUCCESS, POST_PREPARE_FAILURE } from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {
  isLoading: false,
  apiError: null,
};

const fetchPrepareReducer = state => ({
  ...state,
  isLoading: true,
  apiError: null,
});

const prepareSuccessReducer = state => ({
  ...state,
  isLoading: false,
});

const prepareFailureReducer = (state, { payload }) => ({
  ...state,
  isLoading: false,
  apiError: payload.message,
});

export default createReducer(initialState, {
  [POST_PREPARE]: fetchPrepareReducer,
  [POST_PREPARE_SUCCESS]: prepareSuccessReducer,
  [POST_PREPARE_FAILURE]: prepareFailureReducer,
});
